module.exports = __webpack_public_path__ + "static/media/small-payoff.21484fcb.svg";